import React, { useState, useEffect } from "react";
import { Button, TextField, Box, Divider, Typography } from "@material-ui/core";
import { connect } from "react-redux";
import { addNewTag, deleteTag } from "../../Redux/Actions/dataActions";

function ModalContentTag(props) {
  const [tagName, setTagName] = useState("");
  
  // Startwert ist die erste Kategorie (falls vorhanden)
  const [value, setValue] = useState(props.tags && props.tags.length > 0 ? props.tags[0] : "");

  // 🌟 KORREKTUR: Synchronisiert das Dropdown NUR, wenn das aktuell ausgewählte Element 
  // plötzlich nicht mehr in den neuen Kategorien existiert (z.B. weil es gelöscht wurde)
  useEffect(() => {
    if (props.tags && props.tags.length > 0) {
      // Prüfen, ob das aktuell ausgewählte 'value' überhaupt noch in der Liste existiert
      const valueExists = props.tags.includes(value);
      
      // Nur wenn das Element gelöscht wurde oder noch gar kein Wert gesetzt ist,
      // setzen wir das Dropdown wieder krisensicher auf den ersten Eintrag.
      if (!value || !valueExists) {
        setValue(props.tags[0]);
      }
    } else {
      setValue(""); // Keine Kategorien vorhanden
    }
  // 🌟 KORREKTUR: Wir lauschen hier explizit auf die LÄNGE des Arrays statt auf das ganze Objekt.
  // Das verhindert, dass der Effekt bei den 7+ Hintergrund-Updates der Seite anspringt!
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.tags?.length, value]);

  return (
    <Box 
      style={{ 
        width: "100%", 
        maxWidth: "420px", 
        margin: "0 auto", 
        padding: "10px 5px",
        display: "flex",
        flexDirection: "column",
        gap: "20px"
      }}
    >
      {/* Sektion 1: Neue Freitext-Tag hinzufügen */}
      <Box style={{ display: "flex", flexDirection: "column", gap: "12px" }}>
        <Typography variant="caption" style={{ color: "#4f40b3", fontWeight: "bold", letterSpacing: "1px", textTransform: "uppercase" }}>
          Neuen Tag hinzufügen
        </Typography>
        
        <div style={{ display: "flex", gap: "12px", alignItems: "flex-end" }}>
          <TextField
            fullWidth
            variant="outlined"
            size="small"
            label="Tag Name"
            name="tagName"
            value={tagName}
            onChange={(e) => setTagName(e.target.value)}
          />
          <Button
            variant="contained"
            color="primary"
            disabled={tagName.trim() === ""}
            style={{ 
              height: "40px", 
 textTransform: "none",
              borderRadius: "8px",
              backgroundColor: tagName.trim() === "" ? "rgba(0,0,0,0.12)" : "#4f40b3",
              boxShadow: tagName.trim() === "" ? "none" : "0 4px 12px rgba(79, 64, 179, 0.25)"
            }}
            onClick={() => {
              props.addNewTag(tagName, props.sheetName);
              setTagName(""); // Eingabefeld leeren
            }}
          >
            Add
          </Button>
        </div>
      </Box>

      <Divider />

      {/* Sektion 2: Bestehende JSON-Tag löschen */}
      <Box style={{ display: "flex", flexDirection: "column", gap: "12px" }}>
        <Typography variant="caption" style={{ color: "#4f40b3", fontWeight: "bold", letterSpacing: "1px", textTransform: "uppercase" }}>
          Bestehenden Tag löschen
        </Typography>

        {props.tags && props.tags.length > 0 ? (
          <div style={{ display: "flex", gap: "12px", alignItems: "center" }}>
            <select 
              onChange={(e) => setValue(e.target.value)} 
              value={value}
              style={{ 
                flex: 1, 
                height: "40px", 
                borderRadius: "8px", 
                borderColor: "rgba(0,0,0,0.23)", 
                padding: "0 10px",
                fontFamily: "Open Sans",
                fontSize: "14px"
              }}
            >
              {props.tags.map((tag) => (
                <option key={tag} value={tag}>{tag}</option>
              ))}
            </select>
            <Button
              variant="contained"
              disabled={!value}
              style={{ 
                backgroundColor: !value ? "rgba(0,0,0,0.12)" : "tomato", 
                color: "white", 
                height: "40px", 
                textTransform: "none",
                borderRadius: "8px"
              }}
              onClick={() => props.deleteTag(value, props.sheetName)}
            >
              Delete
            </Button>
          </div>
        ) : (
          <span className="sheet_info_info" style={{ fontStyle: "italic" }}>
            Kein Tag zum Löschen vorhanden.
          </span>
        )}
      </Box>

      {/* Sektion 3: Schließen-Button unten */}
      <Box style={{ display: "flex", justifyContent: "flex-end", marginTop: "5px" }}>
        <Button 
          variant="outlined" 
          onClick={props.onClose}
          style={{ borderRadius: "8px", padding: "6px 20px", textTransform: "none" }}
        >
          Close
        </Button>
      </Box>
    </Box>
  );
}

const mapActionsToProps = {
  addNewTag,
  deleteTag,
};

export default connect(null, mapActionsToProps)(ModalContentTag);